import React, { Component, useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { Alert, Tooltip, Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import OutboundIcon from "@mui/icons-material/Outbound";
import DocumentIcon from "@mui/icons-material/Description";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import loadingGif from "../../../../assets/images/aws/loadingGif.gif";

import { enqueueSnackbar } from "notistack";

import {
  getReleaseDetailsRequest,
  clearAllReleaseMessages,
  updateOrgAccount,
  resetOrgAccountStatus,
  // getListOfOrgsAndAccts,
  getListOfAccts,
  clearAllOrgAccountMessages,
} from "../../../../store/actions";
import {
  postFeatureConfiguration,
  clearAllFeatureConfigurationMessages,
} from "../../../../store/featureConfiguration/featureConfigurationSlice";

import UrlDisplayDialog from "../../../../pages/Support/common/UrlDisplayDialog";
import ScriptDisplayDialog from "../../Pricing/ScriptDisplayDialog";
import BucketPolicyModal from "./BucketPolicyModal";
import AddonStatusChip from "../../AddonStatusChip";
import RemediationPreviewPanel from "../../../Common/RemediationPreviewPanel";

const AdditionalAddons = (props) => {
  const {
    releaseDetails,
    isReleaseDetailsGetting,
    getReleaseDetails,
    clearAllReleaseMessages,
    editAccount,
  } = props;
  console.log("AdditionalAddons is rerendered");
  console.log("Additional Addons ::::: ", props);

  const evInsManualConfigGuideLink =
    process.env.REACT_APP_EVENT_INSIGHT_MANUAL_CONFIGURATION_GUIDE;

  console.log("Manual Link :: ", evInsManualConfigGuideLink);
  const coInsManualConfigGuideLink =
    process.env.REACT_APP_COST_INSIGHT_MANUAL_CONFIGURATION_GUIDE;
  const coOptManualConfigGuideLink =
    process.env.REACT_APP_COST_OPTIMIZATION_MANUAL_CONFIGURATION_GUIDE;

  const evInsCliGuideLink = process.env.REACT_APP_EVENT_INSIGHT_CLI_GUIDE;
  const evInsCliScriptLink = process.env.REACT_APP_EVENT_INSIGHT_CLI_SCRIPT;

  const evInsCloudFormationGuideLink =
    process.env.REACT_APP_EVENT_INSIGHT_CLOUDFORMATION_GUIDE;
  const evInsCloudFormationTemplateLink =
    process.env.REACT_APP_EVENT_INSIGHT_CLOUDFORMATION_TEMPLATE;

  const costInsightCloudFormationTemplateLink =
    process.env.REACT_APP_COST_INSIGHT_CLOUDFORMATION_TEMPLATE;
  const costInsightCloudFormationGuideLink =
    process.env.REACT_APP_COST_INSIGHT_CLOUDFORMATION_GUIDE;

  const resourceExplorerGuideLink =
    process.env.REACT_APP_RESOURCE_EXPLORER_MANUAL_GUIDE;

  const [activeSection, setActiveSection] = useState("");
  const [activePart, setActivePart] = useState("");
  const [scriptModalOpen, setScriptModalOpen] = useState(false);
  const [loadingAddon, setLoadingAddon] = useState("");
  // const [addonRows, setAddonRows] = useState([]);

  const [isBucketPolicyModalOpen, setBucketPolicyModalOpen] = useState(false);
  const [isConfirmationOpen, setConfirmationOpen] = useState(false);
  const [addOnsName, setAddOnsName] = useState(null);
  const [isNotificationSent, setNotificationSent] = useState(false);
  const [localGuidePreviewUrl, setLocalGuidePreviewUrl] = useState(null);
  const [localAddonsWithBlueButtonClicked, setLocalAddonsWithBlueButtonClicked] =
    useState(new Set());

  // Edit Account dialog can own this Set so tab switches do not clear the unlock gate.
  const addonsWithBlueButtonClicked =
    props.addonsWithBlueButtonClicked ?? localAddonsWithBlueButtonClicked;

  const markBlueButtonClicked = (addonName) => {
    if (props.markBlueButtonClicked) {
      props.markBlueButtonClicked(addonName);
      return;
    }
    setLocalAddonsWithBlueButtonClicked(
      (prev) => new Set([...prev, addonName])
    );
  };

  const closeBucketPolicyModal = () => {
    setBucketPolicyModalOpen(false);
  };

  const desiredOrder = ["Event Insight", "Cost Insight", "Cost Optimization"];

  const ADDON_PANEL_COPY = {
    "Cost Insight": {
      title: "Cloud Spend Insights",
      description: [
        "Before you begin, ensure you are logged into the AWS account, in the appropriate region, and have full privileges for the account. You must select the US-EAST-01 region for the account before you start.",
        "To configure FinOps, launch the CloudFormation Stack with the guide. To manually configure, select the Manual Set Up guide and follow the instructions.",
      ],
    },
    "Cost Optimization": {
      title: "Cost Optimization",
      description:
        'Enable both Cost Optimization Hub and Compute Optimizer. Then click "Enable" once complete.',
    },
    "Event Insight": {
      title: "Cloud Event",
      description: [
        "Before you begin, ensure you are logged into the AWS account, in the appropriate region, and have full privileges for the account.",
        "To configure Cloud Event, launch the CloudFormation Stack with the guide. To manually configure, select the Manual Set Up guide and follow the instructions.",
      ],
    },
  };

  const renderPanelDescription = (description) => {
    const paragraphs = Array.isArray(description)
      ? description.filter(Boolean)
      : description
        ? [description]
        : [];

    if (!paragraphs.length) return null;

    return (
      <Box
        sx={{
          mb: 1.25,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 1.25,
        }}
      >
        {paragraphs.map((paragraph, index) => (
          <Typography
            key={index}
            sx={{
              color: "#64748b",
              fontSize: "0.875rem",
              fontWeight: 400,
              lineHeight: 1.6,
              width: "100%",
            }}
          >
            {paragraph}
          </Typography>
        ))}
      </Box>
    );
  };

  const CustomFooterComponent = () => (
    <Box
      sx={{
        backgroundColor: '#f9f9f9',
        textAlign: 'center',
        padding: '10px',
        borderTop: '1px solid #e0e0e0',
        display: 'flex',
        justifyContent: 'center',
        gap: '4px', // Space between inline elements
        alignItems: 'center',
      }}
    >
      <span>Have you set up Resource Explorer? If not,</span>
      <a
        href="https://resource-explorer.console.aws.amazon.com/resource-explorer/home?region=us-east-1#/home" // Replace with the actual link
        target="_blank"
        rel="noopener noreferrer"
        style={{
          textDecoration: 'underline',
          color: '#1976d2',
          cursor: 'pointer',
        }}
      >
      click here to enable it</a><span>. For guidance,</span>
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          setActiveSection("Resource Explorer");
          setActivePart("manual");
          getReleaseDetails(resourceExplorerGuideLink);
        }}
        style={{
          textDecoration: 'underline',
          color: '#1976d2',
          cursor: 'pointer',
        }}
      >
        refer to the setup guide</a><span>.</span>
    </Box>
  );

  const linksInfo = [
    {
      sectionName: "Event Insight",
      manualLink: evInsManualConfigGuideLink,
      cliGuideLink: evInsCliGuideLink,
      cliScriptLink: evInsCliScriptLink,
      cloudFormationGuideLink: evInsCloudFormationGuideLink,
      cloudFormationTemplateLink: evInsCloudFormationTemplateLink,
    },
    {
      sectionName: "Cost Insight",
      manualLink: coInsManualConfigGuideLink,
      cliGuideLink: null,
      cliScriptLink: null,
      cloudFormationGuideLink: costInsightCloudFormationGuideLink,
      cloudFormationTemplateLink: costInsightCloudFormationTemplateLink,
    },
    {
      sectionName: "Cost Optimization",
      manualLink: coOptManualConfigGuideLink,
      cliGuideLink: null,
      cliScriptLink: null,
      cloudFormationGuideLink: null,
      cloudFormationTemplateLink: null,
    },
  ];

  const renderInfoIcon = (rowData) => {
    // console.log("rowData = ",rowData);
    const value = rowData.value;
    if (value === 0 && rowData.row.addons === "Cost Insight") {
      return "Free";
    } else {
      return value === "Contact us"
        ? value
        : value === 0
        ? "Free"
        : `$${value}`;
    }
  };

  const handleToggle = (id, action) => {
    const selectedAddOns = additionalAddonsRows.find(
      (addon) => addon.id === id
    );
    console.log("selectedAddOns = ", selectedAddOns);
    console.log("handleToggle id = ", id);
    if (action === "Enable") {
      enableAddOn(selectedAddOns?.name);
    } else if (action === "Disable") {
      disableAddOn(selectedAddOns?.name);
    }
    // setAddonRows((prev) =>
    //   prev.map((row) =>
    //     row.id === id ? { ...row, enabled: !row.enabled } : row
    //   )
    // );
  };

  const enableAddOn = (addOnsName) => {
    console.log("editAccount = ", editAccount);
    setAddOnsName(addOnsName);
    if (addOnsName === "Cost Optimization") {
      enableCostOptimization(addOnsName);
    } else {
      setBucketPolicyModalOpen(true);
    }
  };

  const enableCostOptimization = (addOnsName) => {
    console.log("Enabling Cost Optimization");
    const featureConfigurationRequest = {
      role: "",
      accountNumber: editAccount?.accountNumber,
      bucketName: "",
      readOnlyRole: editAccount?.iamrole,
      selectedRegion: "",
      module: addOnsName,
      externalId: editAccount?.externalId,
    };
    console.log("featureConfigurationRequest = ", featureConfigurationRequest);
    props.postFeatureConfiguration(featureConfigurationRequest);
  };

  const disableAddOn = (addOnsName) => {
    setAddOnsName(addOnsName);
    setConfirmationOpen(true);
  };

  const handleNo = () => {
    setAddOnsName(null);
    setConfirmationOpen(false);
  };

  const handleYes = () => {
    console.log("handle disabling addons");
    console.log("Disable editAccount = ", editAccount);
    console.log("Disable addOns = ", addOnsName);
    setConfirmationOpen(false);

    const unchangedAddOns = editAccount.subscription.addons
      .filter((addon) => addon.name !== addOnsName)
      .map((addon) => ({
        name: addon.name,
        enabled: addon.enabled,
      }));

    const subscriptionRequest = {
      name: editAccount.subscription.name,
      addons: [...unchangedAddOns, { name: addOnsName, enabled: false }],
    };

    // Do not pass compliance addons when we edit addons
    // const unchangedComplianceAddOns = editAccount
    //   .complianceAddOns.map(addOn => ({name: addOn.name, enabled: addOn.enabled}) );

    let accountUpdateRequest = {
      orgId: editAccount.orgId,
      accountNumber: editAccount.accountNumber,
      accountName: editAccount.accountName,
      accountCode: editAccount.accountCode,
      urlLink: editAccount.urlLink,
      accounttype: editAccount.accounttype,
      address: editAccount.address,
      city: editAccount.city,
      state: editAccount.state,
      zip: editAccount.zip,
      country: editAccount.country,
      email: editAccount.email,
      phonenumber: editAccount.phonenumber,
      eula: editAccount.eula,
      accountResourceGroups: editAccount.accountResourceGroups.map((rg) => ({
        resourcename: rg.resourcename,
      })),
      subscription: subscriptionRequest,
      complianceAddOns: [],
      iamrole: editAccount.iamrole,
      externalId: editAccount.externalId,
    };

    console.log("accountUpdateRequest: ", accountUpdateRequest);
    props.updateOrgAccount(accountUpdateRequest);
  };

  // Memoize all functions coming as props
  const resetOrgAccountStatusCallback = useCallback(() => {
    props.resetOrgAccountStatus();
  });

  const getListOfAccts = useCallback(() => {
    props.getListOfAccts();
  });
  // const clearAllOrgAccountMessages = useCallback(() => {props.clearAllOrgAccountMessages();});

  const clearAllFeatureConfigurationMessagesCallback = useCallback(() => {
    props.clearAllFeatureConfigurationMessages();
  });

  const updateMessage = props.updateAccountMessage;
  useEffect(() => {
    console.log("useEffect for updateMessage:", updateMessage);
    if (updateMessage) {
      enqueueSnackbar(updateMessage, { variant: "success" });
      console.log("useEffect for updateMessage: calling resetOrgAccountStatus");
      resetOrgAccountStatusCallback();
      getListOfAccts();
    }
  }, [updateMessage, resetOrgAccountStatusCallback, getListOfAccts]);

  const updateErrorMessage = props.reg_acct_error;
  useEffect(() => {
    console.log("useEffect for updateErrorMessage:", updateErrorMessage);
    if (updateErrorMessage) {
      enqueueSnackbar(updateErrorMessage, { variant: "error" });
      console.log(
        "useEffect for updateErrorMessage: calling resetOrgAccountStatus"
      );
      resetOrgAccountStatusCallback();
    }
  }, [updateErrorMessage, resetOrgAccountStatusCallback]);

  // Handling Message/Error of Enabling Feature
  const postFeatureConfigurationMessage = props.postFeatureConfigurationMessage;
  const postFeatureConfigurationError = props.postFeatureConfigurationError;
  useEffect(() => {
    console.log(
      "useEffect for postFeatureConfigurationMessage:",
      postFeatureConfigurationMessage
    );
    if (postFeatureConfigurationMessage && !isNotificationSent) {
      setBucketPolicyModalOpen(false);
      console.log("Calling enqueSnackbar for postFeatureConfigurationMessage");
      enqueueSnackbar(postFeatureConfigurationMessage, { variant: "success" });
      setNotificationSent(true);
      console.log(
        "useEffect for postFeatureConfigurationMessage: calling clearAllFeatureConfigurationMessages"
      );
      clearAllFeatureConfigurationMessagesCallback();
      getListOfAccts();
    }
  }, [
    postFeatureConfigurationMessage,
    isNotificationSent,
    getListOfAccts,
    clearAllFeatureConfigurationMessagesCallback,
  ]);

  useEffect(() => {
    console.log("useEffect for postFeatureConfigurationError:");
    if (postFeatureConfigurationError) {
      enqueueSnackbar(postFeatureConfigurationError, { variant: "error" });
      console.log(
        "useEffect for postFeatureConfigurationMessage: calling clearAllFeatureConfigurationMessages"
      );
      clearAllFeatureConfigurationMessagesCallback();
    }
  }, [
    postFeatureConfigurationError,
    clearAllFeatureConfigurationMessagesCallback,
  ]);

  // Helper function to check if a row is disabled
  const isRowDisabled = (rowName) => {
    return (
      (rowName === "Cost Insight" && !props.editAccount.costInsight_status) ||
      (rowName === "Cost Optimization" && !props.editAccount.costOptimization_status) ||
      (rowName === "Event Insight" && !props.editAccount.eventInsight_status)
    );
  };

  const lockedFeatureTooltip = "This feature is locked, please contact support.cloudcatcher@cloudnovatech.com";

  let additionalAddonsColumns = [
    // { field: "id", headerName: "ID", width: 50, sortable: false },
    {
      field: "addons",
      headerName: "Addons",
      flex: 2.2,
      minWidth: 160,
      sortable: false,
      renderCell: (rowData) => {
        // console.log("rowData.field = ", rowData);
        const rowDisabled = isRowDisabled(rowData.row.name);
        
        let content;
        if (rowData.row.name === "Event Insight") {
          content = (
            <>
              Cloud Event
              <Tooltip
                title="Please contact support if you would like to use encryption for CloudTrail logs."
                placement="top"
              >
                <IconButton size="small" color="primary">
                  <InfoIcon />
                </IconButton>
              </Tooltip>
            </>
          );
        } else if (rowData.row.name === "Cost Insight") {
          // Check if we should show account scope info
          const costInsightAddon = editAccount?.subscription?.addons?.find(
            (addon) => addon.name === "Cost Insight"
          );
          const isMaster = editAccount?.is_master;
          const isEnabled = costInsightAddon?.enabled;
          const description = costInsightAddon?.description;

          // Only show if master account and FinOps is enabled
          const shouldShowInfo = isMaster && isEnabled && description;

          let scopeText = "";
          if (description === "MASTER_AND_ALL_MEMBERS") {
            scopeText = "All Organization accounts";
          } else if (description === "MASTER_AND_ONBOARDED_MEMBERS_ONLY") {
            scopeText = "On-boarded accounts only";
          }

          content = (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 0.35,
                lineHeight: 1.4,
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              <Box
                component="span"
                sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", columnGap: 0.5, rowGap: 0.25 }}
              >
                <span>FinOps</span>
                {shouldShowInfo && scopeText ? (
                  <span style={{ color: "rgba(0, 0, 0, 0.6)", fontSize: "0.875rem" }}>({scopeText})</span>
                ) : null}
              </Box>
              <Typography
                variant="caption"
                sx={{
                  color: "rgba(0, 0, 0, 0.5)",
                  fontSize: "0.75rem",
                  fontWeight: 400,
                  lineHeight: 1.3,
                }}
              >
                Run in us-east-1 Region
              </Typography>
            </Box>
          );
        } else if (rowData.row.name === "Cost Optimization") {
          content = <>Cost Optimization</>;
        }

        // Wrap content in tooltip if row is disabled
        if (rowDisabled) {
          return (
            <Tooltip title={lockedFeatureTooltip} placement="top">
              <Box 
                sx={{ 
                  display: "inline-block", 
                  width: "100%",
                  pointerEvents: "auto", // Allow tooltip to work
                  cursor: "help" // Show help cursor to indicate tooltip
                }}
              >
                {content}
              </Box>
            </Tooltip>
          );
        }

        return content;
      },
    },

    {
      field: "Configuration",
      headerName: "Manual Configuration",
      flex: 1.2,
      minWidth: 130,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (rowData) => {
        console.log("rowData Manual Config : ", rowData);
        const rowDisabled = isRowDisabled(rowData.row.name);
        const sectionLinksInfo = linksInfo.find(
          (section) => section.sectionName === rowData.row.name
        );

        if (!sectionLinksInfo) return null;

        let content;
        if (rowData.row.name === "Cost Optimization") {
          content = (
            <Box
              sx={{
                display: "flex",
                gap: "10px", // Space between buttons
                justifyContent: "center", // Center the buttons
                alignItems: "center",
              }}
            >
              {sectionLinksInfo.manualLink ? (
                <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  markBlueButtonClicked(rowData.row.name);
                  setActiveSection(sectionLinksInfo.sectionName);
                  setActivePart("manual");
                  getReleaseDetails(sectionLinksInfo.manualLink);
                }}
                  style={{ cursor: "pointer" }}
                  disabled={isReleaseDetailsGetting || rowDisabled}
                >
                  {activeSection === rowData.row.name &&
                  activePart === "manual" &&
                  isReleaseDetailsGetting ? (
                    <img src={loadingGif} height={20} alt="Loading Spinner" />
                  ) : (
                    <Tooltip title="View Documentation" arrow>
                      <DocumentIcon fontSize="small" color="primary" />
                    </Tooltip>
                  )}
                </IconButton>
              ) : null}
              {/* Button 1 */}
              <Tooltip title="Cost Optimization Hub" arrow>
                <IconButton
                  variant="contained"
                  color="primary"
                  size="small"
                  onClick={() => {
                    markBlueButtonClicked(rowData.row.name);
                    window.open(
                      "https://us-east-1.console.aws.amazon.com/costmanagement/home?region=us-east-1#/cost-optimization-hub/enrollment",
                      "_blank"
                    );
                  }}
                  disabled={rowDisabled}
                >
                  <OutboundIcon 
                    fontSize="medium" 
                    sx={{
                      color: "#0d47a1",
                      ...(!rowData.row.enabled && {
                        animation: "pulseArrow 1.2s ease-in-out infinite",
                      }),
                    }}
                  />
                </IconButton>
              </Tooltip>

              {/* Button 2 */}
              <Tooltip title="Compute Optimizer" arrow>
                <IconButton
                  variant="contained"
                  color="secondary"
                  size="small"
                  onClick={() => {
                    markBlueButtonClicked(rowData.row.name);
                    window.open(
                      "https://us-east-1.console.aws.amazon.com/compute-optimizer/home?region=us-east-1#/",
                      "_blank"
                    );
                  }}
                  disabled={rowDisabled}
                >
                  <OutboundIcon 
                    fontSize="medium" 
                    sx={{
                      color: "#0d47a1",
                      ...(!rowData.row.enabled && {
                        animation: "pulseArrow 1.2s ease-in-out infinite",
                      }),
                    }}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          );
        } else {
          content = (
            <div
              style={{
                width: "100%",
                textAlign: "center",
              }}
            >
              {sectionLinksInfo.manualLink ? (
                    <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      markBlueButtonClicked(rowData.row.name);  // ← needed for Cloud Event + FinOps
                      setActiveSection(sectionLinksInfo.sectionName);
                      setActivePart("manual");
                      getReleaseDetails(sectionLinksInfo.manualLink);
                    }}
                  style={{ cursor: "pointer" }}
                  disabled={isReleaseDetailsGetting || rowDisabled}
                >
                  {activeSection === rowData.row.name &&
                  activePart === "manual" &&
                  isReleaseDetailsGetting ? (
                    <img src={loadingGif} height={20} alt="Loading Spinner" />
                  ) : (
                    <Tooltip title="View Documentation" arrow>
                      <DocumentIcon fontSize="small" color="primary" />
                    </Tooltip>
                  )}
                </IconButton>
              ) : null}
            </div>
          );
        }

        // Wrap content in tooltip if row is disabled
        if (rowDisabled) {
          return (
            <Tooltip title={lockedFeatureTooltip} placement="top">
              <Box 
                sx={{ 
                  display: "inline-block", 
                  width: "100%",
                  pointerEvents: "auto", // Allow tooltip to work
                  cursor: "help" // Show help cursor to indicate tooltip
                }}
              >
                {content}
              </Box>
            </Tooltip>
          );
        }

        return content;
      },
    },
    // {
    //   field: "cli",
    //   headerName: "CLI",
    //   width: 100,
    //   sortable: false,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: (rowData) => {
    //     // console.log("rowData : ", rowData);
    //     const sectionLinksInfo = linksInfo.find(
    //       (section) => section.sectionName === rowData.row.name
    //     );

    //     if (!sectionLinksInfo) return null;

    //     return (
    //       <div
    //         style={{
    //           // backgroundColor: "lightskyblue",
    //           width: "100%",
    //           textAlign: "center",
    //         }}
    //       >
    //         {sectionLinksInfo.cliGuideLink && (
    //           <IconButton
    //             onClick={(e) => {
    //               e.stopPropagation();
    //               setModalType("help");
    //               setActiveSection(sectionLinksInfo.sectionName);
    //               setActivePart("cli-help");
    //               setHelpModalOpen(true);
    //               getReleaseDetails(sectionLinksInfo.cliGuideLink);
    //             }}
    //             style={{ cursor: "pointer" }}
    //             disabled={isReleaseDetailsGetting}
    //           >
    //             {activeSection === rowData.row.name &&
    //             activePart === "cli-help" &&
    //             isReleaseDetailsGetting ? (
    //               <img src={loadingGif} height={20} alt="Loading Spinner" />
    //             ) : (
    //               <DocumentIcon fontSize="small" color="primary" />
    //             )}
    //           </IconButton>
    //         )}
    //         {sectionLinksInfo.cliScriptLink && (
    //           <IconButton
    //             onClick={(e) => {
    //               e.stopPropagation();
    //               setModalType("script");
    //               setActiveSection(sectionLinksInfo.sectionName);
    //               setActivePart("cli-script");
    //               setScriptModalOpen(true);
    //               getReleaseDetails(sectionLinksInfo.cliScriptLink);
    //             }}
    //             style={{ cursor: "pointer" }}
    //             disabled={isReleaseDetailsGetting}
    //           >
    //             {activeSection === rowData.row.name &&
    //             activePart === "cli-script" &&
    //             isReleaseDetailsGetting ? (
    //               <img src={loadingGif} height={20} alt="Loading Spinner" />
    //             ) : (
    //               <OutboundIcon fontSize="small" color="primary" />
    //             )}
    //           </IconButton>
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      field: "cloudformation",
      headerName: "Cloudformation",
      flex: 1,
      minWidth: 110,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (rowData) => {
        // console.log("rowData : ", rowData);
        const rowDisabled = isRowDisabled(rowData.row.name);
        const sectionLinksInfo = linksInfo.find(
          (section) => section.sectionName === rowData.row.name
        );
        if (!sectionLinksInfo) return null;

        const content = (
          <div
            style={{
              // backgroundColor: "lightskyblue",
              width: "100%",
              textAlign: "center",
            }}
          >
            {sectionLinksInfo.cloudFormationGuideLink && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setActiveSection(sectionLinksInfo.sectionName);
                  setActivePart("cf-help");
                  getReleaseDetails(sectionLinksInfo.cloudFormationGuideLink);
                }}
                style={{ cursor: "pointer" }}
                disabled={isReleaseDetailsGetting || rowDisabled}
              >
                {activeSection === rowData.row.name &&
                activePart === "cf-help" &&
                isReleaseDetailsGetting ? (
                  <img src={loadingGif} height={20} alt="Loading Spinner" />
                ) : (
                  <Tooltip title="View Documentation" arrow>
                    <DocumentIcon fontSize="small" color="primary" />
                  </Tooltip>
                )}
              </IconButton>
            )}
            {sectionLinksInfo.cloudFormationTemplateLink && (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  markBlueButtonClicked(rowData.row.name);
                  setActiveSection(sectionLinksInfo.sectionName);
                  setActivePart("cf-link");
                  getReleaseDetails(
                    sectionLinksInfo.cloudFormationTemplateLink
                  );
                }}
                style={{ cursor: "pointer" }}
                disabled={isReleaseDetailsGetting || rowDisabled}
              >
                {activeSection === rowData.row.name &&
                activePart === "cf-link" &&
                isReleaseDetailsGetting ? (
                  <img src={loadingGif} height={20} alt="Loading Spinner" />
                ) : (
                  <OutboundIcon 
                    fontSize="medium" 
                    sx={{
                      color: "#0d47a1",
                      ...(!rowData.row.enabled && {
                        animation: "pulseArrow 1.2s ease-in-out infinite",
                      }),
                    }}
                  />
                )}
              </IconButton>
            )}
          </div>
        );

        // Wrap content in tooltip if row is disabled
        if (rowDisabled) {
          return (
            <Tooltip title={lockedFeatureTooltip} placement="top">
              <Box 
                sx={{ 
                  display: "inline-block", 
                  width: "100%",
                  pointerEvents: "auto", // Allow tooltip to work
                  cursor: "help" // Show help cursor to indicate tooltip
                }}
              >
                {content}
              </Box>
            </Tooltip>
          );
        }

        return content;
      },
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.9,
      minWidth: 120,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (rowData) => {
        const { name } = rowData.row;
        const isDisabled =
          (name === "Cost Insight" && !props.editAccount.costInsight_status) ||
          (name === "Cost Optimization" &&
            !props.editAccount.costOptimization_status) ||
          (name === "Event Insight" && !props.editAccount.eventInsight_status);

        // Enable button should be blurred if addon is not enabled AND no blue button has been clicked
        const isAddonEnabled = rowData.row.enabled;
        const hasBlueButtonClicked = addonsWithBlueButtonClicked.has(name);
        const shouldBlurEnableButton = !isAddonEnabled && !hasBlueButtonClicked;
        const isButtonDisabled = 
          props.updateAccountLoading ||
          props.isPostingFeatureConfiguration ||
          props.getOrgAcctsLoading ||
          isDisabled ||
          shouldBlurEnableButton;

        const buttonContent = (
          <Button
            variant="contained"
            disabled={isButtonDisabled}
            sx={{
              backgroundColor: rowData.row.enabled ? "#f44336" : "#1976d2", // Red for "Disable", Blue for "Enable"
              color: "#fff", // White text color
              opacity: shouldBlurEnableButton ? 0.4 : 1,
              filter: shouldBlurEnableButton ? "blur(2px)" : "none",
              cursor: shouldBlurEnableButton ? "not-allowed" : "pointer",
              "&:hover": {
                backgroundColor: rowData.row.enabled ? "#d32f2f" : "#1565c0", // Darker shades on hover
              },
            }}
            onClick={() => {
              if (!shouldBlurEnableButton) {
                setLoadingAddon(rowData.row.name);
                handleToggle(
                  rowData.row.id,
                  rowData.row.enabled ? "Disable" : "Enable"
                );
              }
            }}
          >
            {loadingAddon === rowData.row.name &&
            (props.updateAccountLoading ||
              props.isPostingFeatureConfiguration ||
              props.getOrgAcctsLoading) ? (
              <img src={loadingGif} height={20} alt="Loading Spinner" />
            ) : rowData.row.enabled ? (
              "Disable"
            ) : (
              "Enable"
            )}
          </Button>
        );

        // Wrap button in tooltip if row is disabled
        if (isDisabled) {
          return (
            <Tooltip title={lockedFeatureTooltip} placement="top">
              <Box 
                sx={{ 
                  display: "inline-block",
                  pointerEvents: "auto", // Allow tooltip to work
                  cursor: "help" // Show help cursor to indicate tooltip
                }}
              >
                {buttonContent}
              </Box>
            </Tooltip>
          );
        }

        return buttonContent;
      },
    },
  ];

  if (props.orgLicensing.data.licenseName === "AwsMarketPlaceLicense") {
    additionalAddonsColumns = additionalAddonsColumns.filter(
      (column) => column.field !== "price"
    );
  }

  let additionalAddonsRows = [];
  let sortedAddOns = [];
  sortedAddOns = [...props.addOns].sort(
    (a, b) => desiredOrder.indexOf(a.name) - desiredOrder.indexOf(b.name)
  );
  if (props.addOns) {
    additionalAddonsRows = sortedAddOns.map(
      (addOn, index) => (
        console.log("Addons :: ", addOn),
        {
          id: index + 1, // Ensure each row has a unique id
          name: addOn.name,
          enabled: addOn.enabled,
          price: addOn.price,
        }
      )
    );
  }

  const openGuideDocument = (url) => {
    if (props.onOpenGuidePreview) {
      props.onOpenGuidePreview(url);
      return;
    }
    setLocalGuidePreviewUrl(url);
  };

  // Watch for releaseDetails changes
  useEffect(() => {
    if (releaseDetails && activeSection && activePart) {
      if (activePart === "cf-link") {
        const urlResponse = `https://console.aws.amazon.com/cloudformation/home#/stacks/create/review?templateURL=${encodeURIComponent(
          releaseDetails
        )}`;
        window.open(urlResponse, "_blank", "noopener,noreferrer");
      } else {
        openGuideDocument(releaseDetails);
      }
      clearAllReleaseMessages();
    }
  }, [releaseDetails, activeSection, activePart]);

  const copyToClipboard = (value) => {
    if (!value || !navigator?.clipboard) return;
    navigator.clipboard.writeText(value);
  };

  const renderAddonPanel = (addonName) => {
    const addonRow = additionalAddonsRows.find((row) => row.name === addonName);
    const sectionLinksInfo = linksInfo.find(
      (section) => section.sectionName === addonName
    );
    const copy = ADDON_PANEL_COPY[addonName] || { title: addonName, description: "" };
    const rowDisabled = isRowDisabled(addonName);
    const isAddonEnabled = !!addonRow?.enabled;
    const hasBlueButtonClicked = addonsWithBlueButtonClicked.has(addonName);
    const shouldBlurEnableButton = !isAddonEnabled && !hasBlueButtonClicked;
    // Enable unlocks after a setup link click; do not keep it locked via eventInsight_status/etc.
    const isButtonDisabled =
      props.updateAccountLoading ||
      props.isPostingFeatureConfiguration ||
      props.getOrgAcctsLoading ||
      shouldBlurEnableButton;

    const outlineBtnSx = {
      textTransform: "none",
      color: "#2563eb",
      border: "none",
      backgroundColor: "transparent",
      fontWeight: 500,
      fontSize: "0.8125rem",
      borderRadius: "6px",
      px: 1,
      py: 0.5,
      boxShadow: "none",
      "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "underline",
        border: "none",
      },
    };

    const pillBtnSx = {
      textTransform: "none",
      color: "#2563eb",
      border: "1px solid #2563eb",
      backgroundColor: "#fff",
      fontWeight: 500,
      fontSize: "0.8125rem",
      borderRadius: "999px",
      px: 1.5,
      py: 0.25,
      boxShadow: "none",
      minHeight: 32,
      "&:hover": {
        backgroundColor: "#eff6ff",
        border: "1px solid #2563eb",
      },
    };

    const launchCloudFormationButton = sectionLinksInfo?.cloudFormationTemplateLink ? (
        <Button
          key="cf-launch"
          variant="outlined"
          sx={pillBtnSx}
          disabled={isReleaseDetailsGetting}
          endIcon={
            activeSection === addonName &&
            activePart === "cf-link" &&
            isReleaseDetailsGetting ? (
              <img src={loadingGif} height={16} alt="Loading" />
            ) : (
              <OutboundIcon sx={{ fontSize: 16 }} />
            )
          }
          onClick={() => {
            markBlueButtonClicked(addonName);
            setActiveSection(addonName);
            setActivePart("cf-link");
            getReleaseDetails(sectionLinksInfo.cloudFormationTemplateLink);
          }}
        >
          Launch CloudFormation
        </Button>
    ) : null;
    const manualSetupButton = sectionLinksInfo?.manualLink ? (
        <Button
          key="manual"
          variant="text"
          sx={outlineBtnSx}
          disabled={isReleaseDetailsGetting}
          startIcon={
            activeSection === addonName &&
            activePart === "manual" &&
            isReleaseDetailsGetting ? (
              <img src={loadingGif} height={16} alt="Loading" />
            ) : (
              <DocumentIcon sx={{ fontSize: 16 }} />
            )
          }
          onClick={() => {
            markBlueButtonClicked(addonName);
            setActiveSection(addonName);
            setActivePart("manual");
            getReleaseDetails(sectionLinksInfo.manualLink);
          }}
        >
          Manual Setup
        </Button>
    ) : null;
    const cloudFormationSetupButton = sectionLinksInfo?.cloudFormationGuideLink ? (
        <Button
          key="cf-guide"
          variant="outlined"
          sx={pillBtnSx}
          disabled={isReleaseDetailsGetting}
          endIcon={
            activeSection === addonName &&
            activePart === "cf-help" &&
            isReleaseDetailsGetting ? (
              <img src={loadingGif} height={16} alt="Loading" />
            ) : (
              <DocumentIcon sx={{ fontSize: 16 }} />
            )
          }
          onClick={() => {
            markBlueButtonClicked(addonName);
            setActiveSection(addonName);
            setActivePart("cf-help");
            getReleaseDetails(sectionLinksInfo.cloudFormationGuideLink);
          }}
        >
          CloudFormation Guide
        </Button>
    ) : null;
    const setupButtons = (
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "max-content max-content",
          columnGap: 1,
          rowGap: 1,
          alignItems: "center",
          justifyItems: "start",
        }}
      >
        {launchCloudFormationButton}
        {manualSetupButton}
        {cloudFormationSetupButton}
      </Box>
    );
    const enableDisableButton = (
      <Button
        variant="contained"
        disabled={isButtonDisabled}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          fontSize: "0.8125rem",
          borderRadius: "8px",
          boxShadow: "none",
          backgroundColor: isAddonEnabled ? "#ef4444" : "#16a34a",
          color: "#FFFFFF",
          border: "none",
          opacity: shouldBlurEnableButton ? 0.4 : 1,
          filter: shouldBlurEnableButton ? "blur(2px)" : "none",
          cursor: shouldBlurEnableButton ? "not-allowed" : "pointer",
          "&:hover": {
            boxShadow: "none",
            backgroundColor: isAddonEnabled ? "#dc2626" : "#15803d",
            border: "none",
          },
          "&.Mui-disabled": {
            backgroundColor: isAddonEnabled ? "#ef4444" : "#16a34a",
            color: "#FFFFFF",
          },
        }}
        onClick={() => {
          if (!addonRow || shouldBlurEnableButton) return;
          setLoadingAddon(addonName);
          handleToggle(addonRow.id, isAddonEnabled ? "Disable" : "Enable");
        }}
      >
        {loadingAddon === addonName &&
        (props.updateAccountLoading ||
          props.isPostingFeatureConfiguration ||
          props.getOrgAcctsLoading) ? (
          <img src={loadingGif} height={20} alt="Loading Spinner" />
        ) : isAddonEnabled ? (
          "Disable"
        ) : (
          "Enable"
        )}
      </Button>
    );

    const formatConfigMetaDate = (dateInput) => {
      if (!dateInput || dateInput === "null") return "—";
      if (typeof dateInput === "object" && dateInput.date) {
        const { year, month, day } = dateInput.date;
        const dt = new Date(year, month - 1, day);
        if (isNaN(dt.getTime())) return "—";
        return dt.toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        });
      }
      const dt = new Date(dateInput);
      if (isNaN(dt.getTime())) return String(dateInput);
      return dt.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    };

    const configRows = [];
    let configMeta = null;
    if (addonName === "Cost Insight") {
      const costConfig = editAccount?.costConfigDetailsDto;
      if (costConfig) {
        configRows.push({
          label: "Role ARN",
          value: costConfig.configRoleReplicationArn || "",
        });
        configRows.push({
          label: "S3 Bucket ARN",
          value: costConfig.configS3Arn || "",
        });
        configRows.push({
          label: "Region",
          value: costConfig.configRegion || "",
        });
        configRows.push({
          label: "Stack Name (Optional)",
          value: costConfig.configStackName || "",
        });
        configMeta = {
          enabled: formatConfigMetaDate(costConfig.configEnabledDate),
          enabledBy: costConfig.lastModifiedBy || "—",
          lastModified: formatConfigMetaDate(costConfig.configModifiedDate),
        };
      }
    } else if (addonName === "Event Insight") {
      const eventConfig = editAccount?.eventConfigDetailsDto;
      if (eventConfig) {
        configRows.push({
          label: "Role ARN",
          value: eventConfig.configRoleReplicationArn || "",
        });
        configRows.push({
          label: "Region",
          value: eventConfig.configRegion || "",
        });
        configRows.push({
          label: "Stack Name (Optional)",
          value: eventConfig.configStackName || "",
        });
        configMeta = {
          enabled: formatConfigMetaDate(eventConfig.configEnabledDate),
          enabledBy: eventConfig.lastModifiedBy || "—",
          lastModified: formatConfigMetaDate(eventConfig.configModifiedDate),
        };
      }
    } else if (addonName !== "Cost Optimization" && editAccount?.iamrole) {
      configRows.push({ label: "Role ARN", value: editAccount.iamrole });
    }

    const cardSx = {
      border: "1px solid #e5e7eb",
      borderRadius: "12px",
      p: 2.5,
      backgroundColor: "#f3f4f6",
    };
    const cardTitleRowSx = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
      flexWrap: "wrap",
      gap: 2,
      pb: 1.25,
      mb: 1.25,
      borderBottom: "1px solid #e5e7eb",
    };

    if (addonName === "Cost Optimization") {
      const actionLinkSx = {
        ...outlineBtnSx,
        px: 0,
        justifyContent: "flex-start",
      };
      const pillBtnSx = {
        textTransform: "none",
        color: "#2563eb",
        border: "1px solid #2563eb",
        backgroundColor: "#fff",
        fontWeight: 500,
        fontSize: "0.8125rem",
        borderRadius: "999px",
        px: 1.5,
        py: 0.25,
        boxShadow: "none",
        minHeight: 32,
        "&:hover": {
          backgroundColor: "#eff6ff",
          border: "1px solid #2563eb",
        },
      };

      const openManualSetup = () => {
        if (!sectionLinksInfo?.manualLink) return;
        markBlueButtonClicked(addonName);
        setActiveSection(addonName);
        setActivePart("manual");
        getReleaseDetails(sectionLinksInfo.manualLink);
      };

      const manualSetupButton = (key) => (
        <Button
          key={key}
          variant="text"
          sx={actionLinkSx}
          disabled={isReleaseDetailsGetting || rowDisabled || !sectionLinksInfo?.manualLink}
          startIcon={
            activeSection === addonName &&
            activePart === "manual" &&
            isReleaseDetailsGetting ? (
              <img src={loadingGif} height={16} alt="Loading" />
            ) : (
              <DocumentIcon sx={{ fontSize: 16 }} />
            )
          }
          onClick={openManualSetup}
        >
          Guide
        </Button>
      );

      const costOptEnableButton = (
        <Button
          variant="contained"
          disabled={isButtonDisabled}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "0.8125rem",
            minWidth: 88,
            px: 2,
            py: 0.75,
            alignSelf: "center",
            borderRadius: "8px",
            boxShadow: "none",
            backgroundColor: isAddonEnabled ? "#ef4444" : "#16a34a",
            color: "#FFFFFF",
            border: "none",
            opacity: shouldBlurEnableButton ? 0.4 : 1,
            filter: shouldBlurEnableButton ? "blur(2px)" : "none",
            cursor: shouldBlurEnableButton ? "not-allowed" : "pointer",
            "&:hover": {
              boxShadow: "none",
              backgroundColor: isAddonEnabled ? "#dc2626" : "#15803d",
              border: "none",
            },
            "&.Mui-disabled": {
              backgroundColor: isAddonEnabled ? "#ef4444" : "#16a34a",
              color: "#FFFFFF",
            },
          }}
          onClick={() => {
            if (!addonRow || shouldBlurEnableButton) return;
            setLoadingAddon(addonName);
            handleToggle(addonRow.id, isAddonEnabled ? "Disable" : "Enable");
          }}
        >
          {loadingAddon === addonName &&
          (props.updateAccountLoading ||
            props.isPostingFeatureConfiguration ||
            props.getOrgAcctsLoading) ? (
            <img src={loadingGif} height={20} alt="Loading Spinner" />
          ) : isAddonEnabled ? (
            "Disable"
          ) : (
            "Enable"
          )}
        </Button>
      );

      const actionRows = (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "max-content max-content",
            columnGap: 2,
            rowGap: 1.25,
            alignItems: "center",
            justifyItems: "start",
          }}
        >
          <Button
            variant="outlined"
            sx={pillBtnSx}
            disabled={rowDisabled}
            endIcon={<OutboundIcon sx={{ fontSize: 16 }} />}
            onClick={() => {
              markBlueButtonClicked(addonName);
              window.open(
                "https://us-east-1.console.aws.amazon.com/costmanagement/home?region=us-east-1#/cost-optimization-hub/enrollment",
                "_blank"
              );
            }}
          >
            Enable Cost Optimization Hub
          </Button>
          {manualSetupButton("manual-hub")}
          <Button
            variant="outlined"
            sx={pillBtnSx}
            disabled={rowDisabled}
            endIcon={<OutboundIcon sx={{ fontSize: 16 }} />}
            onClick={() => {
              markBlueButtonClicked(addonName);
              window.open(
                "https://us-east-1.console.aws.amazon.com/compute-optimizer/home?region=us-east-1#/",
                "_blank"
              );
            }}
          >
            Enable Compute Optimizer
          </Button>
          {manualSetupButton("manual-compute")}
        </Box>
      );

      return (
        <Box sx={cardSx}>
          <Box sx={cardTitleRowSx}>
            <Typography sx={{ fontWeight: 700, color: "#111827", fontSize: "1rem" }}>
              {copy.title}
            </Typography>
            <AddonStatusChip active={isAddonEnabled} />
          </Box>
          {renderPanelDescription(copy.description)}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1.5,
            }}
          >
            {rowDisabled ? (
              <Tooltip title={lockedFeatureTooltip}>
                <Box component="span" sx={{ display: "block" }}>{actionRows}</Box>
              </Tooltip>
            ) : (
              actionRows
            )}
            {rowDisabled ? (
              <Tooltip title={lockedFeatureTooltip}>
                <Box component="span" sx={{ display: "inline-flex" }}>
                  {costOptEnableButton}
                </Box>
              </Tooltip>
            ) : (
              costOptEnableButton
            )}
          </Box>
        </Box>
      );
    }

    return (
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box sx={cardSx}>
          <Box sx={cardTitleRowSx}>
            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}>
              <Typography sx={{ fontWeight: 700, color: "#111827", fontSize: "1rem" }}>
                {copy.title}
              </Typography>
              {addonName === "Event Insight" && (
                <Tooltip
                  title="Please contact support if you would like to use encryption for CloudTrail logs."
                  placement="top"
                  arrow
                >
                  <IconButton size="small" color="primary" sx={{ p: 0.25 }}>
                    <InfoIcon sx={{ fontSize: 18 }} />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
            <AddonStatusChip active={isAddonEnabled} />
          </Box>
          {renderPanelDescription(copy.description)}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              gap: 1.5,
            }}
          >
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
              {setupButtons}
            </Box>
            {enableDisableButton}
          </Box>
        </Box>

        {isAddonEnabled && configRows.length > 0 && (
          <Box sx={cardSx}>
            <Box
              sx={{
                pb: 1.25,
                mb: 1.25,
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              <Typography sx={{ fontWeight: 700, color: "#111827", fontSize: "1rem" }}>
                Current Configuration Details
              </Typography>
              {configMeta && (
                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    columnGap: 2,
                    rowGap: 0.75,
                    mt: 1,
                    width: "100%",
                  }}
                >
                  {[
                    { label: "Enabled", value: configMeta.enabled },
                    { label: "Enabled by", value: configMeta.enabledBy },
                    { label: "Last Modified", value: configMeta.lastModified },
                  ].map((item, index) => (
                    <React.Fragment key={item.label}>
                      {index > 0 && (
                        <Box
                          component="span"
                          aria-hidden
                          sx={{
                            width: 3,
                            height: 3,
                            borderRadius: "50%",
                            backgroundColor: "#94a3b8",
                            flexShrink: 0,
                            alignSelf: "center",
                            display: { xs: "none", sm: "inline-block" },
                          }}
                        />
                      )}
                      <Typography
                        sx={{
                          fontSize: "0.75rem",
                          fontWeight: 400,
                          color: "#64748b",
                          lineHeight: 1.4,
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item.label}: {item.value}
                      </Typography>
                    </React.Fragment>
                  ))}
                </Box>
              )}
            </Box>
            {configRows.map((row) => (
              <Box
                key={row.label}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  justifyContent: "space-between",
                  gap: 2.5,
                  py: 1.75,
                  px: 0.25,
                  borderBottom: "1px solid #e5e7eb",
                  "&:last-child": { borderBottom: "none", pb: 0 },
                  "&:first-of-type": { pt: 0.5 },
                }}
              >
                <Box sx={{ minWidth: 0, flex: 1, pr: 1 }}>
                  <Typography
                    sx={{
                      fontSize: "0.7rem",
                      fontWeight: 600,
                      letterSpacing: "0.06em",
                      textTransform: "uppercase",
                      color: "#94a3b8",
                      mb: 0.6,
                    }}
                  >
                    {row.label}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "0.875rem",
                      fontWeight: 600,
                      color: "#0f172a",
                      wordBreak: "break-word",
                      overflowWrap: "anywhere",
                      lineHeight: 1.45,
                    }}
                  >
                    {row.value || "—"}
                  </Typography>
                </Box>
                <IconButton
                  size="small"
                  onClick={() => copyToClipboard(row.value)}
                  sx={{ mt: 0.25, flexShrink: 0 }}
                >
                  <ContentCopyIcon sx={{ fontSize: 16, color: "#64748b" }} />
                </IconButton>
              </Box>
            ))}
          </Box>
        )}
      </Box>
    );
  };

  const renderDisableConfirmationDialog = (onHeaderClose) => (
    <Dialog
      open={isConfirmationOpen}
      onClose={(_event, reason) => {
        if (reason === "backdropClick") return;
        onHeaderClose();
      }}
      maxWidth="xs"
      fullWidth
      sx={{ zIndex: 1400 }}
      PaperProps={{
        sx: {
          borderRadius: "12px",
          overflow: "hidden",
        },
      }}
    >
      <Box
        sx={{
          px: 3,
          py: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 2,
          backgroundColor: "#F98125",
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            fontSize: "1.15rem",
            color: "#FFFFFF",
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
          }}
        >
          Confirmation for Disabling Addon
        </Typography>
        <button
          type="button"
          aria-label="Close"
          onClick={onHeaderClose}
          style={{
            padding: 0,
            margin: 0,
            border: "none",
            background: "transparent",
            color: "#FFFFFF",
            fontSize: 28,
            fontWeight: 700,
            lineHeight: 1,
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            opacity: 1,
            boxShadow: "none",
            flexShrink: 0,
          }}
        >
          <span aria-hidden="true">×</span>
        </button>
      </Box>
      <DialogContent sx={{ px: 3, py: 2.5 }}>
        <Typography
          sx={{
            fontSize: "0.9375rem",
            fontWeight: 400,
            color: "#334155",
            lineHeight: 1.5,
          }}
        >
          Are you sure you want to disable addon?
        </Typography>
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: 1.25,
          }}
        >
          <Button
            variant="outlined"
            onClick={handleNo}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              borderRadius: "8px",
              px: 2.5,
              color: "#475569",
              borderColor: "#cbd5e1",
              "&:hover": {
                borderColor: "#94a3b8",
                backgroundColor: "#f8fafc",
              },
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            onClick={handleYes}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              fontSize: 14,
              borderRadius: "8px",
              px: 2.5,
              boxShadow: "none",
              backgroundColor: "#ef4444",
              color: "#fff",
              "&:hover": {
                backgroundColor: "#dc2626",
                boxShadow: "none",
              },
            }}
          >
            Yes
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );

  const sharedAddonModals = (
    <>
      {scriptModalOpen && releaseDetails && (
        <ScriptDisplayDialog
          url={releaseDetails}
          pageTitle="Help"
          isOpen={scriptModalOpen}
          setOpen={setScriptModalOpen}
          clearUrl={clearAllReleaseMessages}
        />
      )}
      {isBucketPolicyModalOpen && addOnsName && (
        <BucketPolicyModal
          isOpen={isBucketPolicyModalOpen}
          closeModal={closeBucketPolicyModal}
          addOnsName={addOnsName}
          editAccount={editAccount}
          accounts={props.accounts}
          setNotificationSent={setNotificationSent}
        />
      )}
      {isConfirmationOpen && renderDisableConfirmationDialog(handleNo)}
      {!props.onOpenGuidePreview && (
        <RemediationPreviewPanel
          url={localGuidePreviewUrl}
          onClose={() => setLocalGuidePreviewUrl(null)}
          title="Guide"
        />
      )}
    </>
  );

  if (props.addonName) {
    return (
      <Box sx={{ width: "100%" }}>
        {renderAddonPanel(props.addonName)}
        {sharedAddonModals}
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <style>
        {`
          @keyframes pulseArrow {
            0%, 100% {
              opacity: 1;
              transform: scale(1);
              filter: drop-shadow(0 0 3px rgba(13, 71, 161, 0.8));
            }
            50% {
              opacity: 0.9;
              transform: scale(1.2);
              filter: drop-shadow(0 0 8px rgba(13, 71, 161, 1));
            }
          }
        `}
      </style>
      <Alert variant="outlined" severity="info" icon={false}>
        Please select any Additional Services and configure them through any of
        the available options below.
      </Alert>
      <DataGrid
        rows={additionalAddonsRows}
        columns={additionalAddonsColumns}
        disableColumnFilter
        disableColumnSelector
        disableDensitySelector
        disableColumnMenu
        hideFooterSelectedRowCount
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        autoHeight
        rowHeight={64}
        getRowClassName={(params) => {
          const { name } = params.row;
          if (
            (name === "Cost Insight" &&
              !props.editAccount.costInsight_status) ||
            (name === "Cost Optimization" &&
              !props.editAccount.costOptimization_status) ||
            (name === "Event Insight" && !props.editAccount.eventInsight_status)
          ) {
            return "blurred-row"; // Apply this class to rows that should be blurred
          }
          return "";
        }}
          sx={{
            width: "100%",
            maxWidth: "100%",
            border: "none",
            /* Let wrapped text (e.g. FinOps + region note) show; default grid cells clip overflow */
            "& .MuiDataGrid-main": {
              overflowX: "hidden",
            },
            "& .MuiDataGrid-virtualScroller": {
              overflowX: "hidden !important",
            },
            "& .MuiDataGrid-columnHeaders": {
              minHeight: "44px !important",
              lineHeight: 1.25,
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              whiteSpace: "normal",
              lineHeight: 1.25,
              fontWeight: 600,
              fontSize: "0.8125rem",
            },
            "& .MuiDataGrid-cell": {
              alignItems: "center",
              whiteSpace: "normal",
              lineHeight: 1.4,
              py: 0.75,
              overflow: "visible",
            },
            "& .blurred-row": {
              opacity: 0.5, // Make rows appear blurred
              cursor: "not-allowed", // Show disabled cursor
            },
            "& .blurred-row .MuiIconButton-root, & .blurred-row .MuiButton-root": {
              pointerEvents: "none", // Disable button interactions
            },
            "& .blurred-row .MuiTooltip-root": {
              pointerEvents: "auto", // Allow tooltips to work
            },
        }}
        slots={{
          footer: CustomFooterComponent, 
        }}
      />

      {scriptModalOpen && releaseDetails && (
        <ScriptDisplayDialog
          url={releaseDetails}
          pageTitle="Help"
          isOpen={scriptModalOpen}
          setOpen={setScriptModalOpen}
          clearUrl={clearAllReleaseMessages}
        />
      )}
      {/* Modal for Bucket Policy Verification */}
      {isBucketPolicyModalOpen && addOnsName && (
        <BucketPolicyModal
          isOpen={isBucketPolicyModalOpen}
          closeModal={closeBucketPolicyModal}
          addOnsName={addOnsName}
          editAccount={editAccount}
          accounts={props.accounts}
          setNotificationSent={setNotificationSent}
        />
      )}

      {/* Modal for confirmation of Disabling  addon*/}
      {isConfirmationOpen && renderDisableConfirmationDialog(props.closeModal)}
      {!props.onOpenGuidePreview && (
        <RemediationPreviewPanel
          url={localGuidePreviewUrl}
          onClose={() => setLocalGuidePreviewUrl(null)}
          title="Guide"
        />
      )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  const {
    accounts,
    organizations,
    reg_acct_error,
    account,
    loading: updateAccountLoading,
    message: updateAccountMessage,
  } = state.orgAccount;

  const {
    loading: getOrgAcctsLoading,
    message: getOrgAcctsMessage,
    error: getOrgAcctsError,
  } = state.acctList;
  const {
    isReleaseDetailsGetting,
    getReleaseDetailsMessage,
    getReleaseDetailsError,
    releaseDetails,
  } = state.releaseNotes;

  const {
    isPostingFeatureConfiguration,
    postFeatureConfigurationMessage,
    postFeatureConfigurationError,
  } = state.featureConfiguration;

  return {
    isReleaseDetailsGetting,
    getReleaseDetailsMessage,
    getReleaseDetailsError,
    releaseDetails,

    accounts,
    organizations,
    reg_acct_error,
    account,
    updateAccountLoading,
    updateAccountMessage,
    orgLicensing: state.licensing,

    getOrgAcctsLoading,
    getOrgAcctsMessage,
    getOrgAcctsError,

    isPostingFeatureConfiguration,
    postFeatureConfigurationMessage,
    postFeatureConfigurationError,

    orgLicensing: state.licensing,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getReleaseDetails: (fileName) => {
      dispatch(getReleaseDetailsRequest(fileName));
    },
    clearAllReleaseMessages: () => {
      dispatch(clearAllReleaseMessages());
    },
    // getListOfOrgsAndAccts: () => {
    //   dispatch(getListOfOrgsAndAccts());
    // },
    getListOfAccts: () => {
      dispatch(getListOfAccts());
    },
    updateOrgAccount: (data) => {
      dispatch(updateOrgAccount(data));
    },
    // clearAllOrgAccountMessages: () => {
    //   dispatch(clearAllOrgAccountMessages());
    // },
    resetOrgAccountStatus: () => {
      dispatch(resetOrgAccountStatus(null));
    },
    postFeatureConfiguration: (featureConfigurationPayload) => {
      dispatch(postFeatureConfiguration(featureConfigurationPayload));
    },
    clearAllFeatureConfigurationMessages: () => {
      dispatch(clearAllFeatureConfigurationMessages());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdditionalAddons);
